import { render } from "./company-consolidation-settings-modal.vue?vue&type=template&id=b8f6bfa5&scoped=true"
import script from "./company-consolidation-settings-modal.vue?vue&type=script&lang=js"
export * from "./company-consolidation-settings-modal.vue?vue&type=script&lang=js"

import "./company-consolidation-settings-modal.vue?vue&type=style&index=0&id=b8f6bfa5&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8f6bfa5"]])

export default __exports__